// extracted by mini-css-extract-plugin
module.exports = {"container":"text-intro_container__B7yxL","title":"text-intro_title__Zrh4n","description":"text-intro_description__48E8V"};